
import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);
const APIURL = process.env.NODE_ENV === 'production' ? 'https://ab6hq7fv4b.execute-api.eu-west-1.amazonaws.com/production/se-api/' : 'https://6crydqahcf.execute-api.eu-west-1.amazonaws.com/dev/se-api/';

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    url: APIURL,
    status: '',
    ets: '',
    enterprise: null,
    cognitoUser: null,
    clientname64: '',
    cognitoAccess: null,
    role: [],
    closeAllTimeRows: false,
    transitionWindow: false,
    beaconInfo: {},
    apik: null,
    apikResponseTs: 0,
    surveyQuestion: 'survey_form.final_survey_question',
    productionZones: [],
    timesheet2: [],
    timesheet: [],
  },
  mutations: {
    authSucceeded: (state, token) => {
      state.status = 'success';
      state.token = token;
    },
    setEnterprise: (state, enterprise) => {
      state.enterprise = enterprise;
      if (enterprise) {
        state.clientname64 = enterprise.id64;
      } else {
        state.clientname64 = null;
      }
    },
    setUser: (state, user) => {
      state.cognitoUser = user;
    },
    deleteRow: (state, rowStart) => {
      const rowToDelete = state.timesheet.findIndex(row => row.start === rowStart);
      if (rowToDelete > 0 && (
        (!state.timesheet[rowToDelete - 1].productionArea || state.timesheet[rowToDelete - 1].productionArea === 'unknown')
        || (!state.timesheet[rowToDelete + 1].productionArea || state.timesheet[rowToDelete + 1].productionArea === 'unknown'))) {
        state.timesheet.splice(rowToDelete, 1);
      } else {
        console.log('state.timesheet[rowToDelete]: ', state.timesheet[rowToDelete]);
        const tempRow = state.timesheet[rowToDelete];
        tempRow.productionArea = 'unknown';
        Vue.set(state.timesheet, rowToDelete, tempRow);
        console.log('state.timesheet: ', state.timesheet);
      }
    },
    closeAllTimeRows: (state) => {
      state.closeAllTimeRows = !state.closeAllTimeRows;
    },
    editRow: (state, idx, payload) => {
      Vue.set(state.timesheet, idx, payload);
    },
    changeTransitionWindow: (state) => {
      state.transitionWindow = !state.transitionWindow;
    },
    getBeaconInfo: (state, beacon) => {
      state.beaconInfo = beacon;
    },
    setApik: (state, apik) => {
      state.apik = apik;
      state.apikResponseTs = Math.round((new Date()).getTime() / 1000);
    },
    getOperatorTimesheet: (state, logs) => {
      state.timesheet = logs;
    },
    getProductionZones: (state, productionZones) => {
      state.productionZones = productionZones;
    },
    onUnvalidAPIkey: (state) => {
      state.apik = {};
      state.timesheet2 = [];
      state.timesheet = [];
      state.apik = null;
      state.beaconInfo = {};
      state.apikResponseTs = 0;
    },
    clearApiKey: (state) => {
      state.apik = {};
      state.timesheet2 = [];
      state.timesheet = [];
      state.apik = null;
      state.beaconInfo = {};
      state.apikResponseTs = 0;
    },
  },
  actions: {
    setUser: (context, user) => {
      context.commit('setUser', user);
    },
    setEnterprise: (context, enterprise) => {
      context.commit('setEnterprise', enterprise);
    },
    authSucceeded: (context, token) => {
      context.commit('authSucceeded', token);
    },
    userLogout: (context) => {
      context.commit('setUser', null);
      context.commit('setApik', null);
    },
    deleteRow: ({ state }, rowDeleted) => {
      const rowToDelete = {};
      rowToDelete.beaconID = state.beaconInfo.beaconID;
      rowToDelete.startOriginal = rowDeleted.start;
      rowToDelete.endOriginal = rowDeleted.end;

      return axios.post(`${APIURL}${state.clientname64}/deletelog`, rowToDelete)
        .then(response => response)
        .catch((err) => {
          console.log('Error on deleteRow: ', err);
        });
    },
    closeAllTimeRows: (context) => {
      context.commit('closeAllTimeRows');
    },
    editRow: (context, idx, payload) => {
      context.commit('editRow', idx, payload);
    },
    changeTransitionWindow: (context) => {
      context.commit('changeTransitionWindow');
    },
    getBeaconInfo: ({ commit, state }, payload) => axios.get(`${APIURL}${state.clientname64}/beaconsshortid/${payload}`)
      .then((response) => {
        commit('getBeaconInfo', response.data.Items[0]);
        commit('setApik', response.data.apik);
        return 'OK HERE -----> ';
      })
      .catch((error) => {
        console.log(error);
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.err(error.request);
          commit('userLogout');
        } else {
          // Something happened in setting up the request that triggered an Error
          console.err(error.message);
        }
        console.err(error.config);
        return 'ERROR HERE -----> ';
      }),
    getOperatorTimesheet: ({ commit, state }, beaconID) => {
      const apikCreated = state.apikResponseTs;
      const diffNowApikTs = Math.round((new Date()).getTime() / 1000) - apikCreated;
      const delayBeforeFetchLogs = diffNowApikTs > 30 ? 0 : (30 - diffNowApikTs) * 1000;
      setTimeout(() => {
        axios.get(`${APIURL}${state.clientname64}/logsmerged/${beaconID}`)
          .then((response) => {
            console.log('getOperatorTimesheet response: ', response);
            commit('getOperatorTimesheet', response.data);
          })
          .catch((err) => {
            if (err.response.status === 403) {
              commit('onUnvalidAPIkey');
            }
          });
      }, delayBeforeFetchLogs);
    },
    updateTimeRow({ state }, timeRowUpdated) {
      const rowToUpdate = {};
      rowToUpdate.beaconID = state.beaconInfo.beaconID;
      rowToUpdate.start = timeRowUpdated.start;
      rowToUpdate.end = timeRowUpdated.end;
      rowToUpdate.startOriginal = timeRowUpdated.startOriginal;
      rowToUpdate.endOriginal = timeRowUpdated.endOriginal;
      rowToUpdate.zoneID = timeRowUpdated.productionArea;
      console.log('Action store updateTimeRow -> rowToUpdate: ', rowToUpdate);
      return axios.post(`${APIURL}${state.clientname64}/edition`, rowToUpdate)
        .then((response) => {
          console.log('Res on updateTimeRow: ', response);
          return response;
        })
        .catch((err) => {
          console.log('Error on updateTimeRow: ', err);
        });
    },
    createTimeRow({ state }, timeRowCreated) {
      const rowToCreate = {};
      rowToCreate.beaconID = state.beaconInfo.beaconID;
      rowToCreate.start = timeRowCreated.start;
      rowToCreate.end = timeRowCreated.end;
      rowToCreate.zoneID = String(timeRowCreated.zoneID);
      console.log('createTimeRow store: ', rowToCreate);

      return axios.post(`${APIURL}${state.clientname64}/createlog`, rowToCreate)
        .then((response) => {
          console.log('Res on createTimeRow: ', response);
          return response;
        })
        .catch((err) => {
          console.log('Error on createTimeRow: ', err);
        });
    },
    getProductionZones: ({ commit, state }) => {
      axios.get(`${APIURL}${state.clientname64}/productionzone/`)
        .then((response) => {
          // console.log('getProductionZones response: ', response);
          commit('getProductionZones', response.data.Items);
        })
        .catch(err => console.error('ERROR ON getProductionZones: ', err));
    },
    clearApiKey: ({ commit }) => {
      commit('clearApiKey');
    },
  },
  getters: {
    url: state => state.url,
    cognitoUser: state => state.cognitoUser,
    enterprise: state => state.enterprise,
    isAuthenticated: state => state.cognitoUser !== null,
    isSuperAdmin: state => ((state.cognitoUser) ? state.cognitoUser.info['cognito:groups'].includes('superadmin') : false),
    authStatus: state => state.status,
    getToken: state => state.token,
    getEts: state => state.ets,
    getCognitoAccess: state => state.cognitoAccess,
    getSurveyQuestion: state => state.surveyQuestion,
    getTransitionWindow: state => state.transitionWindow,
    getTimesheet: state => state.timesheet,
    getTimesheet2: state => state.timesheet2[0],
    getCloseAllTimeRows: state => state.closeAllTimeRows,
    getTotalcollected: (state) => {
      const eventsCollected = state.timesheet.filter(data => data.productionArea !== undefined);
      const total = eventsCollected.reduce((sum, item) => sum + (item.end - item.start), 0);
      return total;
    },
    getBeaconInfo: state => state.beaconInfo,
    getBeaconShortID: state => state.beaconInfo.beaconShortID,
    getBeaconID: (state) => {
      if (state.beaconInfo && state.beaconInfo.beaconID) {
        return state.beaconInfo.beaconID;
      }
      return '';
    },
    getApiK: state => state.apik,
    getApikResponseTs: state => state.apikResponseTs,
    getProductionZones: state => state.productionZones,
  },
});
